import Vue from 'vue'
import Router from 'vue-router'
import Monitor from '@/components/Monitor'

import SensorRecord01 from '@/components/SensorRecord01'

Vue.component('SensorRecord01', SensorRecord01)

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/:deviceId?',
      props: true,
      name: 'Monitor',
      component: Monitor,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js